"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PropertyEventType = {
  AUCTION: {
    name: 'AUCTION'
  },
  TENDER: {
    name: 'TENDER'
  },
  PLACE_HOLDER: {
    name: 'PLACE_HOLDER'
  },
  EXHIBITION: {
    name: 'EXHIBITION'
  },
  OPEN_HOURS: {
    name: 'OPEN_HOURS'
  }
};
var _default = exports.default = PropertyEventType;